export enum StorageItem {
  PROFILE = 'PROFILE',
  CONFIGS_HOME = 'CONFIGS_HOME',
  CONFIGS_APPLICATION = 'CONFIGS_APPLICATION',
  CONFIGS_ACCOUNT = 'CONFIGS_ACCOUNT',
  COUNTRY_CODE = 'COUNTRY_CODE',
  USER_INFORMATION = 'USER_INFORMATION',
  TITLE = 'TITLE'
}
